import { render, staticRenderFns } from "./DetailedQuery.vue?vue&type=template&id=4e1d1b9c&scoped=true"
import script from "./DetailedQuery.vue?vue&type=script&lang=js"
export * from "./DetailedQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d1b9c",
  null
  
)

export default component.exports